<template>
  <Splitpanes class="default-theme">
    <Pane min-size="10" size="20">
      <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
        <div v-for="item in folderButton" :key="item.id" class="folderButton">
          <FrameButton :key="item.id" :button="item" :parentData="currentFolder"></FrameButton>
        </div>
        <el-icon :size="24" @click="refreshNode(currentFolder.id)" style="margin-top: 5px">
          <ElIconRefresh class="el-icon-refresh"/>
        </el-icon>
      </div>

      <el-tree
          class="mytree"
          ref="tree"
          :data="folderData"
          :props="defaultProps"
          node-key="id"
          :load="loadNode"
          lazy
          @node-click="nodeClickHandle"
          highlight-current
          :expand-on-click-node="true"
          min-height="500px"
          style="height: 100%;overflow: auto"
      >
      </el-tree>
    </Pane>
    <Pane min-size="50">
      <Splitpanes horizontal>
        <Pane size="60" min-size="5" style="display: flex;flex-direction: column;">
          <div class="card-header" style="width: 100%;padding: 3px;border: solid 1px lightgrey">
            <el-row style="width: 100%">
              <el-col :span="20">
                <span width="100%" class="department-name">{{ currentFolder.full_path }}</span>
                <span class="file-count">【{{ totalCnt }}】</span>
              </el-col>

              <el-col :span="4" align="right" style="display: flex;align-items: center;justify-content: flex-end;">
                <el-popover :width="450" style="border: 1px solid lightgrey">
                  <template #reference>
                    <el-icon :size="22" style="margin-left: 5px">
                      <ElIconFilter class="el-icon-filter" :color="searchData.hasCondition==true?'blue':'#333333'"/>
                    </el-icon>
                  </template>

                  <template #default>
                    <el-form :model="searchData" label-width="90px" style="max-width: 450px">
                      <el-form-item label="文件名">
                        <el-input v-model="searchData.fileName" style="width: 240px" @change="setHasCondition"/>
                      </el-form-item>

                      <el-checkbox-group v-model="searchData.fileTypes" @change="setHasCondition">
                        <el-form-item label="文件类型">
                          <el-checkbox value="word" name="type">Word</el-checkbox>
                          <el-checkbox value="excel" name="type">Excel</el-checkbox>
                          <el-checkbox value="ppt" name="type">PPT</el-checkbox>
                          <el-checkbox value="PDF" name="type">PDF</el-checkbox>
                        </el-form-item>
                        <el-form-item label=" " style="margin-top: -20px">
                          <el-checkbox value="image" name="type">Image</el-checkbox>
                          <el-checkbox value="txt" name="type">TXT</el-checkbox>
                          <el-checkbox value="cad" name="type">CAD</el-checkbox>
                          <el-checkbox value="others" name="type">Others</el-checkbox>
                        </el-form-item>
                      </el-checkbox-group>

                      <el-form-item label="文件状态">
                        <el-radio-group v-model="searchData.fileStatus" @change="setHasCondition">
                          <el-radio-button value="release">发布</el-radio-button>
                          <el-radio-button value="edit">编辑中</el-radio-button>
                          <el-radio-button value="review">审核中</el-radio-button>
                          <el-radio-button value="obsolete">废弃</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="更新日期">
                        <el-radio-group v-model="searchData.updateDateRange" @change="setHasCondition">
                          <el-radio-button value="date_range_0_3">3天内</el-radio-button>
                          <el-radio-button value="date_range_0_7">一周内</el-radio-button>
                          <el-radio-button value="date_range_0_30">一月内</el-radio-button>
                          <el-radio-button value="date_range_31_36500">一月以上</el-radio-button>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label=" ">
                        <el-button type="primary" @click="searchBtn">检索</el-button>
                        <el-button type="primary" @click="clearCondition">清除条件</el-button>
                      </el-form-item>
                    </el-form>
                  </template>
                </el-popover>

                <el-popover :width="260" style="border: 1px solid lightgrey">
                  <template #reference>
                    <el-icon :size="22" style="margin-left: 5px">
                      <ElIconSort class="el-icon-sort" :color="(searchData.searchOrder != 'name')?'blue':'#333333'"/>
                    </el-icon>
                  </template>
                  <template #default>
                    <el-form :model="searchData" label-width="90" style="max-width: 300px">
                      <el-radio-group v-model="searchData.searchOrder" @change="searchBtn">
                        <el-form-item label="文件名称">
                          <el-radio-button value="name">升序</el-radio-button>
                          <el-radio-button value="name desc">降序</el-radio-button>
                        </el-form-item>
                        <el-form-item label="创建时间">
                          <el-radio-button value="create_time">升序</el-radio-button>
                          <el-radio-button value="create_time desc">降序</el-radio-button>
                        </el-form-item>
                        <el-form-item label="更新时间">
                          <el-radio-button value="update_time">升序</el-radio-button>
                          <el-radio-button value="update_time desc">降序</el-radio-button>
                        </el-form-item>
                      </el-radio-group>
                    </el-form>
                  </template>
                </el-popover>

                <FrameButton :parentData="currentFolder" :button="uploadButton" style="margin-right: 5px;"></FrameButton>
              </el-col>
            </el-row>
          </div>

          <div v-loading="loading" element-loading-text="拼命加载中"
               element-loading-background="rgba(0, 0, 0, 0.5)"
               style="background-color: white; overflow-y: auto;height: 100%">
            <div v-if="viewType=='card'" class="doc-box">
              <ModelDocCard
                  v-for="element in docList"
                  :key="element.id"
                  :doc-data="element"
                  :class="element.id==currentDoc.id?'current':''"
                  @click="selectDoc(element)"
                  @openFolder="openFolder"
                  @dblclick="openFolder(element.id)"
              />
            </div>

          </div>
        </Pane>
        <Pane size="40" min-size="5">
          <ModelDocTab v-if="currentDoc.id" :key="currentDoc.id" :doc-data="currentDoc"></ModelDocTab>
        </Pane>

      </Splitpanes>
    </Pane>

  </Splitpanes>
</template>

<script>
import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import ModelDocCard from "@/views/applications/pdm/ModelDocCard.vue";
import ModelDocTab from "@/views/applications/pdm/ModelDocTab.vue";

export default {
  name: "PdmClientIndex",
  components: {ModelDocTab, ModelDocCard, Splitpanes, Pane},
  data() {
    return {
      uploadButton: {
        "component": "button",
        "type": "text",
        "icon": "el-icon-upload",
        "style": "font-size: 22px",
        "icon_only": true,
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "pdm_model_doc_add", "title": "上传文件", "width": 800, "height": 600}
      },
      folderButton: [
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-folder-add",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "window": {"component": "frame/FrameForm", "type": "pdm_catalog_add", "title": "添加子目录", "width": 500, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-edit",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "window": {"component": "frame/FrameForm", "type": "pdm_catalog_edit", "title": "修改目录", "width": 500, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-TopRight",
          "style": "font-size: 24px",
          "icon_only": true,
          "click": "jsOpenDialog",
          "window": {"component": "frame/FrameForm", "type": "pdm_catalog_move", "title": "移动目录和文件", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon": "el-icon-delete",
          "icon_only": true,
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "window": {"component": "frame/FrameForm", "type": "pdm_catalog_del", "title": "删除目录", "width": 600, "height": 300}
        },
        {
          "component": "button",
          "type": "text",
          "icon_only": true,
          "icon": "el-icon-setting",
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "pdm_catalog_setting", "title": "目录设置", "width": 850, "height": 600, "icon": "system/tools"}
        },
        {
          "component": "button",
          "type": "text",
          "icon_only": true,
          "icon": "el-icon-user",
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "click_success": ["jsRefreshForm"],
          "window": {"component": "frame/FrameForm", "type": "pdm_catalog_access_user", "title": "可访问人", "width": 850, "height": 600, "icon": "system/tools"}
        },
        {
          "component": "button",
          "text": true,
          "circle": true,
          "icon_only": true,
          "icon": "el-icon-Grid",
          "style": "font-size: 24px",
          "click": "jsOpenDialog",
          "window": {"component": "frame/FrameForm", "type": "pdm_catalog_import", "title": "导入目录", "width": 500, "height": 300}
        }
      ],
      orderItems: [{"name": "文件名称升序", "value": "name_asc"}, {"name": "文件名称降序", "value": "name_desc"}, {"name": "创建时间升序", "value": "create_time"}, {
        "name": "创建时间降序",
        "value": "-create_time"
      }, {"name": "修改时间升序", "value": "update_time"}, {"name": "修改时间降序", "value": "-update_time"}, {"name": "文件大小升序", "value": "file_size"}, {
        "name": "文件大小降序",
        "value": "-file_size"
      }],
      addData: {parentId: '', name: ''},
      searchData: {hasCondition: false, fileName: '', searchOrder: 'name', fileTypes: [], fileStatus: '', updateDateRange: '', pageSize: 50, pageNum: 1},
      viewType: 'card',
      folderData: [],
      currentFolder: {},
      currentDoc: {},
      subPage: 'user',
      showEditDepartment: false,
      editData: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      docList: [],
      totalCnt: 0,
      loading: false
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          // 刷新当前节点
          this.refreshNode(this.currentFolder.id);
        },
        reloadParentNode: () => {
          //刷新父节点
          console.log("reloadParentNode,parent_id:" + this.currentFolder.parent_id)
          this.refreshNode(this.currentFolder.parent_id);
        },
        searchDoc: () => {
          //查询
          console.log("searchDoc,dir_id:" + this.currentFolder.id)
          this.searchDoc();
        }
      }
    }
  },
  methods: {
    selectDoc(doc) {
      console.log(doc)
      this.currentDoc = doc
    },
    handleSizeChange(size) {
      this.searchData.pageSize = size
      this.searchDoc();
    },
    handleCurrentChange(pageNo) {
      this.searchData.pageNum = pageNo
      this.searchDoc();
    },
    openFolder(nodeId) {
      this.$refs.tree.setCurrentKey(nodeId);
      // 获取节点数据
      const node = this.$refs.tree.getNode(nodeId);
      if (node) {
        // 手动触发 node-click 事件
        this.nodeClickHandle(node.data, node);
      }
    },
    refreshNode(nodeId) {
      if (nodeId && nodeId.length > 0) {
        this.$refs.tree.store.nodesMap[this.currentFolder.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentFolder.id].loadData();
      } else {
        this.loadDirTree()
      }
    },
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentFolder = currentRow
      this.currentPage = 1
      this.searchDoc();
    },
    async loadDirTree() {
      let data = await this.$http('pdmCatalogService.getChildren', {parent_id: ''})
      this.folderData = data;
    },
    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      let data = await this.$http('pdmCatalogService.getChildren', {parent_id: node.data.id})
      resolve(data)
    },
    async searchBtn() {
      this.searchData.pageNum = 1
      this.searchDoc();
    },
    async searchDoc() {
      this.searchData.dirId = this.currentFolder.id
      this.currentDoc = {}

      this.loading = true;
      this.$http('pdmModelDocService.searchDoc', this.searchData, false).then(data => {
        this.loading = false;
        this.docList = data.records
        this.totalCnt = data.total

      }, errMsg => {
        this.loading = false;
        return this.$message.error(errMsg);
      })

      if (this.docList.length > 500) {
        this.$message.warning("检索结果达到上限【500】，建议进行更精确的检索");
      }
    },
    clearCondition() {
      this.searchData.hasCondition = false;
      this.searchData.fileName = '';
      this.searchData.searchOrder = '';
      this.searchData.fileStatus = '';
      this.searchData.updateDateRange = '';
      this.searchData.fileTypes = []
      this.searchDoc();
    },
    setHasCondition() {
      if (this.searchData.fileName.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileStatus.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.fileTypes.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      if (this.searchData.updateDateRange.length > 0) {
        this.searchData.hasCondition = true;
        return
      }

      this.searchData.hasCondition = false;
      return
    }
  },
  created() {

  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.folderButton {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.doc-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  min-height: 600px;
}

.doc-card {
  width: 150px;
  height: 210px;
  margin: 10px;
  border: 1px solid gainsboro;
  border-radius: 10px;
}

.doc-card:hover {
  background-color: #E5F3FF;
}

.current {
  outline: 3px solid red;
}

.file-count {
  color: #409EFF;
  font-size: large;
  margin-left: 5px;
}

.pdf {
  background-image: url("../../../../public/icon/filetype/pdf.png");
}

.excel {
  background-image: url("../../../../public/icon/filetype/excel.png");
}

.word {
  background-image: url("../../../../public/icon/filetype/word.png");
}

.ppt {
  background-image: url("../../../../public/icon/filetype/ppt.png");
}

.png {
  background-image: url("../../../../public/icon/filetype/jpg.png");
}

.file {
  background-image: url("../../../../public/icon/filetype/file.png");
}

.icon {
  width: 100px;
  height: 100px;
  background-size: 100px 100px;
  margin-left: 25px;
}

.doc-name {
  font-size: 16px;
  width: 100%;
  height: 33px;
  margin-top: 10px;
  margin-bottom: 10px;
  //word-wrap: normal;
  word-wrap: break-word;
  word-break: break-all;
  overflow: hidden;
  line-height: 16px;
  padding-left: 10px;
  text-align: center;
}

.doc-version {
  margin-left: 10px;
  font-size: 20px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-author {
  font-size: 16px;
  width: 100%;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.doc-time {
  font-size: 14px;
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: center;
}

.doc-status {
  font-size: 12px;
  width: 100%;
}

.doc-menu {
  font-size: 14px;
  margin: 5px 0 0 5px;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}

.mytree {
  margin-left: -15px;

  :deep(.el-tree-node__content) {
    padding: 0 !important;
  }

  :deep(.el-tree-node) {
    position: relative;
    padding-left: 16px;
  }

  :deep(.el-tree-node__children) {
    padding-left: 16px;
  }

  // 竖线
  :deep(.el-tree-node::before) {
    content: "";
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #b8b9bb;
  }

  :deep(.el-tree-node:last-child::before) {
    height: 38px;
  }

  // 横线
  :deep(.el-tree-node::after) {
    content: "";
    width: 24px;
    height: 20px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #b8b9bb;
  }

  :deep(& > .el-tree-node::after) {
    border-top: none;
  }

  :deep(& > .el-tree-node::before) {
    border-left: none;
  }

  :deep(.el-tree-node__expand-icon) {
    font-size: 16px;
  }

  :deep(.is-leaf) {
    display: none; // 也可以去掉
  }

}
</style>
